import styled, { css } from 'styled-components';
import { mediaMixin, token } from '@zillow/constellation';

export const StyledAutocompleteContainer = styled.div`
    position: relative;
    width: 100%;
    float: left;
    padding-bottom: 8px;

    ${mediaMixin(
        'md',
        css`
            flex: 1;
            margin-right: 16px;
            padding-bottom: 0;
        `
    )};
`;

export const StyledDropdown = styled.div`
    position: absolute;
    width: 100%;
    max-width: 100vw;
    z-index: 100;
    max-height: 100vh;
    border-radius: 0 0 4px 4px;
    margin-top: -2px;
    padding-top: 2px;
    border: 1px solid ${token('colors.gray300')};
    border-top: none;
    text-align: left;
`;

export const StyledDropdownItem = styled.div`
    padding: 0 18px;
    background: ${({ isActive }) => css`
            ${isActive ? token('colors.gray200') : token('colors.white')}
        `};
    cursor: pointer;

    :last-of-type {
        border-radius: 0 0 3px 3px;
    }

    :last-of-type > * {
        border-bottom: none;
    }

    ${mediaMixin(
        'md',
        css`
            padding: 0 24px;
        `
    )};
`;

export const StyledDropdownItemText = styled.div`
    /* must define width in pixels for text truncation */
    width: calc(100% - 0px);
    height: 48px;
    line-height: 46px;
    border-bottom: 1px solid ${token('colors.gray200')};
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;

    ${mediaMixin(
        'md',
        css`
            height: 58px;
            line-height: 56px;
        `
    )};
`;
